import { Component, OnInit } from '@angular/core';
import { OnlineAnswerService } from '../../../services/onlineanswer.service';
import { ActivatedRoute, Params } from '@angular/router';


@Component({
    selector: 'paymentSucceeded',
    templateUrl: 'paymentSucceeded.component.html'
})
export class PaymentSucceededComponent implements OnInit {
    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            var keyId: string = params['key'];
            var keyIdArray: string[] = keyId.split('_');

            this.answerUrl = this.onlineAnswerService.GetDownloadAnswerUrl(keyIdArray[0], keyIdArray[1])
        });
    }

    answerUrl: string = '';

    constructor(private onlineAnswerService: OnlineAnswerService, private route: ActivatedRoute) {

    }


}